export default __webpack_public_path__ + "static/media/m_settings.f68f144b.svg";